document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var variantsElement = section.querySelector('[data-variants-json]');
    var productForm = section.querySelector('form[action*="/cart/add"]');

    if (variantsElement) {
      var variants = JSON.parse(variantsElement.textContent);
      var selected = {};

      section.querySelectorAll('[data-option-value].is-selected').forEach(function (button) {
        selected[button.dataset.optionPosition] = button.dataset.optionValue;
      });

      section.querySelectorAll('[data-option-value]').forEach(function (button) {
        button.addEventListener('click', function () {
          var position = button.dataset.optionPosition;
          selected[position] = button.dataset.optionValue;

          section.querySelectorAll('[data-option-position="' + position + '"][data-option-value]').forEach(function (item) {
            item.classList.toggle('is-selected', item === button);
            item.setAttribute('aria-pressed', item === button ? 'true' : 'false');
          });

          var label = section.querySelector('[data-option-label="' + position + '"]');
          if (label) label.textContent = button.dataset.optionValue;

          if (button.dataset.isColor === 'true') {
            var selectedColor = section.querySelector('[data-selected-color]');
            if (selectedColor) selectedColor.textContent = button.dataset.optionValue;
          }

          var variant = variants.find(function (candidate) {
            return candidate.options.every(function (value, index) {
              return selected[String(index + 1)] === value;
            });
          });

          if (variant) updateVariant(section, variant);
        });
      });
    }

    section.querySelectorAll('[data-thumb]').forEach(function (button) {
      button.addEventListener('click', function () {
        var mainImage = section.querySelector('[data-main-image]');
        if (mainImage) mainImage.src = button.dataset.thumb;
      });
    });

    section.querySelectorAll('[data-minus]').forEach(function (button) {
      button.addEventListener('click', function () {
        var input = button.parentElement.querySelector('input');
        input.value = Math.max(1, Number(input.value || 1) - 1);
      });
    });

    section.querySelectorAll('[data-plus]').forEach(function (button) {
      button.addEventListener('click', function () {
        var input = button.parentElement.querySelector('input');
        input.value = Number(input.value || 1) + 1;
      });
    });

    if (productForm) {
      productForm.addEventListener('submit', async function (event) {
        event.preventDefault();

        var submitter = event.submitter;
        var buyNow = submitter && submitter.hasAttribute('data-buy-now');
        var addButton = section.querySelector('[data-add-to-cart]');
        var buyButton = section.querySelector('[data-buy-now]');
        var variantInput = productForm.querySelector('[name="id"]');

        if (!variantInput || !variantInput.value) {
          alert('Please select a product color before continuing.');
          return;
        }

        if (addButton) {
          addButton.disabled = true;
          addButton.dataset.originalText = addButton.innerHTML;
          addButton.textContent = 'Adding…';
        }
        if (buyButton) buyButton.disabled = true;

        try {
          var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          var response = await fetch(rootPath + 'cart/add.js', {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: new FormData(productForm)
          });

          var result = await response.json();

          if (!response.ok) {
            throw new Error(result.description || result.message || 'This item could not be added to the cart.');
          }

          window.location.href = buyNow ? rootPath + 'checkout' : rootPath + 'cart';
        } catch (error) {
          alert(error.message);
          if (addButton) {
            addButton.disabled = false;
            addButton.innerHTML = addButton.dataset.originalText || '🛒 Add to cart';
          }
          if (buyButton) buyButton.disabled = false;
        }
      });
    }
  });
});

function formatMoney(cents) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(cents / 100);
}

function updateVariant(section, variant) {
  var variantInput = section.querySelector('[data-variant-id]');
  var productPrice = section.querySelector('[data-product-price]');
  var buttonPrice = section.querySelector('[data-button-price]');
  var comparePrice = section.querySelector('[data-compare-price]');
  var discountBadge = section.querySelector('[data-discount-badge]');
  var addButton = section.querySelector('[data-add-to-cart]');
  var buyButton = section.querySelector('[data-buy-now]');

  if (variantInput) variantInput.value = variant.id;
  if (productPrice) productPrice.textContent = formatMoney(variant.price);
  if (buttonPrice) buttonPrice.textContent = formatMoney(variant.price);

  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    if (comparePrice) {
      comparePrice.hidden = false;
      comparePrice.textContent = formatMoney(variant.compare_at_price);
    }
    if (discountBadge) {
      discountBadge.hidden = false;
      discountBadge.textContent =
        Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '% OFF';
    }
  } else {
    if (comparePrice) comparePrice.hidden = true;
    if (discountBadge) discountBadge.hidden = true;
  }

  if (addButton) addButton.disabled = !variant.available;
  if (buyButton) buyButton.disabled = !variant.available;

  if (variant.featured_image && variant.featured_image.src) {
    var mainImage = section.querySelector('[data-main-image]');
    if (mainImage) mainImage.src = variant.featured_image.src;
  }

  var url = new URL(window.location.href);
  url.searchParams.set('variant', variant.id);
  window.history.replaceState({}, '', url.toString());
}


document.addEventListener('DOMContentLoaded', function(){
  document.querySelectorAll('[data-cart-minus]').forEach(function(button){
    button.addEventListener('click', function(){
      var input = button.parentElement.querySelector('input');
      input.value = Math.max(0, Number(input.value || 0) - 1);
    });
  });

  document.querySelectorAll('[data-cart-plus]').forEach(function(button){
    button.addEventListener('click', function(){
      var input = button.parentElement.querySelector('input');
      input.value = Number(input.value || 0) + 1;
    });
  });
});
